import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer id="footer" className="mt-16 bg-secondary-100 border-t border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-xl">
                <i className="ri-fire-line"></i>
              </span>
              <span className="font-heading font-extrabold text-lg text-foreground-950">
                每日大瓜网红大赛百度
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-md">
              专注网红大赛领域的娱乐资讯门户，每日更新最新赛事资讯、赛事动态与精彩回顾，为热爱网红圈热点信息的你提供第一时间的内容服务。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50 text-foreground-600 border border-background-200">
                <i className="ri-weibo-fill text-accent-500"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50 text-foreground-600 border border-background-200">
                <i className="ri-wechat-fill text-accent-500"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50 text-foreground-600 border border-background-200">
                <i className="ri-mail-line text-accent-500"></i>
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm text-foreground-950 mb-4">赛事分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((c) => (
                <li key={c.id}>
                  <Link
                    to={`/category/${c.id}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm text-foreground-950 mb-4">关于本站</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  网站定位
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  内容范围
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  联系方式
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  全部赛事
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 每日大瓜网红大赛百度 · 本站内容均为演示示例 · 京ICP备00000000号
          </p>
          <p className="text-xs text-foreground-500">
            合作邮箱：hello@meiridagua.example.com · 官方微博：@每日大瓜网红大赛
          </p>
        </div>
      </div>
    </footer>
  );
}